import {useState} from 'react'
import {getClient} from '../../central/services'
import {ProfileByUserModel} from '../../central/model'

export const useClients = () => {
  const [clientData, setClientData] = useState<ProfileByUserModel[] | any>([])
  const [isLoading, setIsLoading] = useState(false)

  const getClientList = async (id: any) => {
    setIsLoading(true)
    try {
      const response = await getClient({isCombo: true, companiaId: id}, 1)
      let data = response.data.data
      const mappedSites = data.map((item) => ({value: item.id, label: item.nombre}))
      setClientData(mappedSites)
      setIsLoading(false)
    } catch (error) {}
  }

  return {isLoading, clientData, getClientList, setClientData}
}
